import { Flex, Skeleton, Text } from '@chakra-ui/react';
import { formatDateToDateTimeDisplay } from '@/utils/formatDateToDateTimeDisplay';
import { Account } from '@/model';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface AccountDetailHeaderInfoProps {
  item?: Account;
  isLoading: boolean;
}

export const AccountDetailHeaderInfoComponent = ({ item, isLoading }: AccountDetailHeaderInfoProps) => {
  const { t } = useTranslation();

  return (
    <Flex
      direction='column'
      gap='deci'
      sx={{
        '& > *': {
          minHeight: 'kilo',
        },
      }}
    >
      {!isLoading && (
        <Text>
          {t('pages.accountdetail.components.header_info.creation_date')}{' '}
          <Text as='strong'>{item?.created_at ? formatDateToDateTimeDisplay(item.created_at) : '-'}</Text>
        </Text>
      )}
      {isLoading && <Skeleton noOfLines={1} h='kilo' w={250} />}

      {!isLoading && (
        <Text>
          {t('pages.accountdetail.components.header_info.last_access')}{' '}
          <Text as='strong'>{item?.last_access_at ? formatDateToDateTimeDisplay(item.last_access_at) : '-'}</Text>
        </Text>
      )}
      {isLoading && <Skeleton noOfLines={1} h='kilo' w={250} />}

      {!isLoading && (
        <Text>
          {t('pages.accountdetail.components.header_info.app_version')} <Text as='strong'>{item?.last_app_version || '-'}</Text>
        </Text>
      )}
      {isLoading && <Skeleton noOfLines={1} h='kilo' w={250} />}

      {!isLoading && (
        <Text>
          {t('pages.accountdetail.components.header_info.terms_of_use')}
          <Text as='strong'>
            {/* {t('pages.accountdetail.components.header_info.terms_version', { version: item?.terms_version ?? '0' })} */}
            xxxxxxxxxxxx
            {/* {item?.terms_accepted_at ? formatDateToDateTimeDisplay(item.terms_accepted_at) : '-'} */}
          </Text>
        </Text>
      )}
      {isLoading && <Skeleton noOfLines={1} h='kilo' w={250} />}
    </Flex>
  );
};

export const AccountDetailHeaderInfo = React.memo(AccountDetailHeaderInfoComponent);
